import { Grid } from '@mui/material';
import * as React from 'react';
import MomentosPieChartPanelControl from './components/MomentosPieChartPanelControl';
import PanelControlEstudiosHook from './PanelControlEstudiosHook';

const PanelControlEstudiosView = () => {
  const { bloquesPedagogicos } = PanelControlEstudiosHook();

  return (
    <Grid container spacing={2}>
      <Grid item md={6}>
        <MomentosPieChartPanelControl bloquesPedagogicos={bloquesPedagogicos} />
      </Grid>

      {/* 
      <Grid item md={6}>
        <PieChartPanelControl />
      </Grid>
      <Grid item md={12}>
        <MesesBarChartPanelControl />
      </Grid>
      <Grid item md={6}>
        <LineChartPanelControl />
      </Grid>
      <Grid item md={6}>
        <StackedBarChartPanelControl />
      </Grid>
      <Grid item md={12}>
        <AreaChartPanelControl />
      </Grid> 
      */}
      {/* <AlertWidget alert={panelControlEstudiosStore.alertView} />

        <BotonComponent
          click={async () => {
            await setActivoPanelControlEstudiosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          blue
          mr={2}
        />
        {panelControlEstudiosStore.all.length > 0 ? (
          <BotonComponent
            click={async () => {
              await setActivoPanelControlEstudiosAction(dispatch, null);
              await allPanelControlEstudiosAction(
                dispatch,
                entidadesStore.activo.id,
                null
              );
            }}
            disabled={panelControlEstudiosStore.loadingAll}
            white
            text={
              panelControlEstudiosStore.loadingAll ? "Actualizando..." : "Actualizar"
            }
          />
        ) : null}
      </Grid>
      <ListadoPanelControlEstudios setOpenModalForm={(val) => setOpenModalForm(val)} />

      <Modal
        id="modalFormPanelControlEstudios"
        title={`${panelControlEstudiosStore.activo ? "Editar" : "Nuevo"} documento`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {panelControlEstudiosStore.activo ? (
          <Typography variant="h6">
            {panelControlEstudiosStore.activo.nombres} {panelControlEstudiosStore.activo.apellidos}
          </Typography>
        ) : null}
        <FormPanelControlEstudios
          activo={panelControlEstudiosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal> */}
    </Grid>
  );
};

export default PanelControlEstudiosView;
